let OptionsConsumptionGas = [
    { "label":"1000", "value":"1000" },
    { "label":"3000", "value":"3000" },
    { "label":"5000", "value":"5000" }
]

//- ---

let OptionsConsumptionLuce = [
    { "label":"1100", "value":"1100" },
    { "label":"3100", "value":"3100" },
    { "label":"5100", "value":"5100" }
]

export { OptionsConsumptionGas, OptionsConsumptionLuce }